<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="background: #f3f3f3;height: 30px;line-height:30px;padding: 0 25px;display: flex; align-items: center;"
        >
          <div>仓储APP更新配置</div>
        </div>
        <el-collapse-transition>
          <div>
            <div style="padding: 10px 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="是否强制更新：">
                  <el-select v-model="form.is_update" style="width: 150px;">
                    <el-option
                      v-for="item in update_data"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 10px 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="版本号：">
                  <el-input
                    v-model="form.version"
                    :placeholder="resData.version"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 10px 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="下载链接：">
                  <el-input
                    v-model="form.ref"
                    :placeholder="resData.ref"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 10px 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="更新说明：">
                  <el-input
                    v-model="form.remark"
                    type="textarea"
                    :rows="10"
                    :placeholder="resData.remark"
                  >
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-button type="primary" @click="comfresh">保存</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData(true);
    });
  },
  data() {
    return {
      resData: {
        version: null,
      },
      form: {
        is_update: "",
        version: "",
        remark: "",
        ref: "",
      },
      update_data: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      url: "/erp/Common/getVersion",
    };
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      let form = {
        key: "warehouse_app_version",
      };
      this.$http.post(this.url, form).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.resData = res.data.data;
          this.form.is_update = this.resData.is_update;
          this.form.version = this.resData.version;
          this.form.remark = this.resData.remark;
          this.form.ref = this.resData.ref;
          // this.splitData(this.resData);
        }
      });
    },
    comfresh() {
      let url = "/erp/Setting/saveWarehouseAppVersion";
      let data = {
        is_update: this.form.is_update || "",
        version: this.form.version || "",
        remark: this.form.remark || "",
        ref: this.form.ref || "",
      };
      this.$http.post(url, data).then(res => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/WarehouseAppVersionSetting.vue